<script>
    import logo from '../assets/logo-footer.svg'
    import instagram from '../assets/instagram.svg'
    import facebook from '../assets/facebook.svg'
    import twitter from '../assets/twitter.svg'
    import linkedin from '../assets/linkedin.svg'
    import ssn from '../assets/ssn.svg'
    import qr_afip from '../assets/qr_afip.svg'
    import pdp from '../assets/pdp.svg'
    import sectigo from '../assets/sectigo.svg'
    import commodo from '../assets/comodo.svg'
</script>

<div class="container">
    <div class="footer">
        <img draggable="false" class="logo" src={logo} alt="" />
        <div class="text-cobertura">
            Consultá acerca de las coberturas, sus límites, condiciones de
            suscripción y exclusiones de la póliza.<br />
            Los Seguros son emitidos por Caja de Seguros S.A.<br />
            Fitz Roy 957 (C1414CHI) C.A.B.A. - CUIT 30-66320562-1
        </div>
        <div class="redes">
            <div class="text-social">Seguinos en nuestras redes</div>
            <div class="container-social">
                <a
                    href="https://www.instagram.com/seguroslacaja/"
                    target="_blank"
                    ><img
                        draggable="false"
                        class="social"
                        src={instagram}
                        alt=""
                    /></a
                >
                <a
                    href="https://www.facebook.com/seguroslacaja/"
                    target="_blank"
                    ><img
                        draggable="false"
                        class="social"
                        src={facebook}
                        alt=""
                    /></a
                >
                <a href="https://twitter.com/seguroslacaja" target="_blank"
                    ><img
                        draggable="false"
                        class="social"
                        src={twitter}
                        alt=""
                    /></a
                >
                <a
                    href="https://www.linkedin.com/company/la-caja"
                    target="_blank"
                    ><img
                        draggable="false"
                        class="social"
                        src={linkedin}
                        alt=""
                    /></a
                >
            </div>
        </div>
    </div>
    <div class="footer section2">
        <div class="sec2-col sec2-col-bor-right">
            N° de inscripción en SSN<br />0501
        </div>
        <div class="sec2-col sec2-col-bor-right">
            Atención al asegurado<br />0800-666-8400
        </div>
        <div class="sec2-col sec2-col-bor-right">
            Organismo de Control<br />www.ssn.gob.ar
        </div>
        <div class="sec2-col">
            <img draggable="false" class="ssn" src={ssn} alt="" />
        </div>
    </div>
    <div class="section3">
        La entidad aseguradora dispone de un Servicio de Atención al Asegurado
        que atenderá las consultas y reclamos que presenten los tomadores de
        seguros, asegurados, beneficiarios y/o derechohabientes.
        <br /><br />
        El Servicio de Atención al Asegurado está integrado por: Responsable: Sandra
        Sevillano Suplente: Ariel Mariano Zabaleta Tel: 4857-7677 opción 2
        <br /><br />
        En caso de que el reclamo no haya sido resuelto o haya sido desestimado,
        total o parcialmente, o que haya sido denegada su admisión, podrá comunicarse
        con la Superintendencia de Seguros de la Nación por teléfono al 0800-666-8400,
        correo electrónico a denuncias@ssn.gob.ar o formulario web a través de www.argentina.gob.ar/ssn
    </div>
    <div class="section4">
        <div class="sec4-col1">
            <img draggable="false" class="" src={qr_afip} alt="" />
        </div>
        <div class="sec4-col">
            <img draggable="false" class="" src={pdp} alt="" />
        </div>
        <div class="sec4-col">
            <img draggable="false" class="" src={sectigo} alt="" />
        </div>
        <div class="sec4-col">
            <img draggable="false" class="" src={commodo} alt="" />
        </div>
    </div>
</div>

<style>
    .container {
        display: grid;
        /* grid-template-rows: 72px 1fr; */
        width: auto;
        height: 530px;
        /* position: absolute; */
        background: var(--color-background-container-footer);
    }
    .footer {
        width: auto;
        height: 150px;
        position: relative;
        top: 20px;
        margin: 0;
        padding: 0 0 0 68px;
        display: flex;
        flex-direction: row;
        align-items: center;
        left: 0;
        /* z-index: var(--lvl-3); */
        background: var(--color-background-footer);
    }
    .logo {
        user-select: none;
        height: 104.27px;
        width: 88px;
    }
    .redes {
        position: relative;
        width: 50%;
        padding-top: 20px;
        flex-grow: 0;
    }
    .footer div:last-child {
        float: right;
    }
    .social {
        padding: 8px;
    }
    .text-cobertura {
        width: 457px;
        height: 68px;
        margin-left: 30px;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
        color: #ffffff;
        flex-grow: 0;
    }
    .text-social {
        padding-right: 8px;
        margin-bottom: 8px;
        height: 17px;
        text-align: end;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
        color: #ffffff;
    }
    .container-social {
        display: flex;
    }
    .section2 {
        position: relative;
        top: 0;
        padding-right: 100px;
        height: 100px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-top: 0.5px solid #ffffff;
    }
    .sec2-col {
        width: 25%;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0.4px;
        color: #ffffff;
    }
    .ssn {
        width: 242px;
        height: 70px;
    }
    .sec2-col-bor-right {
        border-right: 0.5px solid #ffffff;
    }
    .section3 {
        position: relative;
        top: 5px;
        margin-left: 68px;
        margin-right: 68px;
        display: flex;
        align-items: left;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
        color: #ffffff;
        opacity: 0.3;
    }
    .section4 {
        position: relative;
        top: 20px;
        height: 80px;
        margin-left: 68px;
        display: flex;
        flex-direction: row;
    }
    .sec4-col1 {
        width: 8%;
    }
    .sec4-col {
        width: 11%;
    }
</style>
